import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { Header } from "../styled";
import { List, Tile, Name, Description, ListWrapper, TileLink, TileImage, TextWrapper, LearnMore } from "./styled";
import { useTranslation } from "react-i18next";
import { LINKS, getLocalizedRoute } from "../../../config/links";
import cruiseImage from "./images/cruiseHero480p.webp";
import housesImage from "./images/housesHero480p.webp";
import bikesImage from "./images/bikesHero480p.webp";
import boatsImage from "./images/boatsHero480p.webp";

const images = {
    cruises: cruiseImage,
    houses: housesImage,
    bikes: bikesImage,
    boats: boatsImage,
};

const Offer = () => {
    const { t, i18n } = useTranslation();
    const current = i18n.resolvedLanguage || i18n.language;

    return (
        <ListWrapper id={LINKS.sections.services}>
            <StaggeredContainer>
                <StaggeredItem>
                    <Header>{t("offer.title")}</Header>
                </StaggeredItem>

                <StaggeredItem>
                    <List>
                        {LINKS.offerItems.map((item) => (
                            <Tile key={item.key}>
                                <TileLink to={getLocalizedRoute(LINKS.routes[item.hrefKey], current)}>
                                    <TileImage
                                        src={images[item.key]}
                                        alt={t(`offer.items.${item.key}.name`)}
                                        loading="lazy"
                                    />
                                    <TextWrapper>
                                        <Name>{t(`offer.items.${item.key}.name`)}</Name>
                                        <Description>{t(`offer.items.${item.key}.description`)}</Description>
                                        <LearnMore>{t("offer.learnMore")}</LearnMore>
                                    </TextWrapper>
                                </TileLink>
                            </Tile>
                        ))}
                    </List>
                </StaggeredItem>
            </StaggeredContainer>
        </ListWrapper>
    );
};

export default Offer;